import type { Formatters } from './format';
import type { UsageCopy } from './copy';

export interface ServiceRow {
  key: string;
  label: string;
  color: string;
  credits: number;
  share: number;
  avg: number;
}

/**
 * Credits by service as the one table (DESIGN-SPEC §3.5): it keeps its natural
 * width and scrolls sideways, with the right edge fading, instead of wrapping.
 */
export function ServiceTable({
  rows,
  total,
  avg,
  copy,
  f,
  onHighlight,
}: {
  rows: ServiceRow[];
  total: number;
  avg: number;
  copy: UsageCopy;
  f: Formatters;
  onHighlight?: (index: number) => void;
}) {
  return (
    <div className="ws-scroll-fade cu-table-wrap">
      <table className="cu-table w-max min-w-full text-left text-sm">
        <thead className="text-ui whitespace-nowrap text-[var(--ws-muted)] [&_th]:font-medium">
          <tr>
            <th>{copy.service}</th>
            <th className="cu-td-r">{copy.credits}</th>
            <th className="cu-td-r">{copy.share}</th>
            <th className="cu-td-r">{copy.avgPerDay}</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr
              key={row.key}
              onMouseEnter={() => onHighlight?.(index)}
              onMouseLeave={() => onHighlight?.(-1)}
            >
              <td>
                <span className="cu-svc-name">
                  <span className="cu-key" style={{ background: row.color }} />
                  {row.label}
                </span>
              </td>
              <td className="cu-td-r">{f.int(row.credits)}</td>
              <td className="cu-td-r">{f.percent(row.share)}</td>
              <td className="cu-td-r">{f.one(row.avg)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="is-total">
            <td>{copy.total}</td>
            <td className="cu-td-r">{f.int(total)}</td>
            <td className="cu-td-r">{f.percent(total > 0 ? 100 : 0)}</td>
            <td className="cu-td-r">{f.one(avg)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
